import { render } from "./SampleValidation.vue?vue&type=template&id=3de6059a"
import script from "./SampleValidation.vue?vue&type=script&lang=js"
export * from "./SampleValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__